// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"441":"01844a02","836":"01844a02"}[chunkId] + ".chunk.css";
};